export default ({ children = null } = {}) => children;



// WEBPACK FOOTER //
// ./src/@ui/NativeWebRouter/DeepLinking.web.js